import ArticleTemplate from './ArticleTemplate';
import { allArticles } from './data';

export default function ShoesArticlePage() { return <ArticleTemplate article={allArticles[1]} />; }